(function () {
  'use strict';

  var body = document.body;
  var drawer = document.querySelector('[data-mobile-drawer]');
  var drawerToggle = document.querySelector('[data-mobile-toggle]');
  var drawerLastFocus = null;

  function focusableElements(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function setPageInert(inert) {
    ['.site-header', '#MainContent', '.site-footer'].forEach(function (selector) {
      var element = document.querySelector(selector);
      if (element) element.inert = inert;
    });
  }

  function setDrawer(open) {
    drawer = document.querySelector('[data-mobile-drawer]');
    drawerToggle = document.querySelector('[data-mobile-toggle]');
    if (!body || !drawer) return;
    var shouldOpen = Boolean(open);
    if (shouldOpen === body.classList.contains('nav-open')) return;
    if (shouldOpen) drawerLastFocus = document.activeElement;
    body.classList.toggle('nav-open', shouldOpen);
    drawer.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    if (drawerToggle) drawerToggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    setPageInert(shouldOpen);
    if (shouldOpen) {
      var focusables = focusableElements(drawer);
      (focusables[0] || drawer).focus();
    } else if (drawerLastFocus && drawerLastFocus.focus) {
      drawerLastFocus.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-mobile-toggle]')) {
      event.preventDefault();
      setDrawer(true);
    } else if (target.closest('[data-mobile-close]')) {
      event.preventDefault();
      setDrawer(false);
    } else if (target.closest('.mobile-drawer a')) {
      setDrawer(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    drawer = document.querySelector('[data-mobile-drawer]');
    if (!body || !body.classList.contains('nav-open') || !drawer) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      setDrawer(false);
      return;
    }
    if (event.key !== 'Tab') return;
    var focusables = focusableElements(drawer);
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 1280) setDrawer(false);
  });

  function initAnnouncementRotators(root) {
    (root || document).querySelectorAll('[data-announcement-rotator]:not([data-initialized])').forEach(function (rotator) {
      rotator.setAttribute('data-initialized', 'true');
      var messages = Array.prototype.slice.call(rotator.querySelectorAll('[data-announcement-message]'));
      var mobileQuery = window.matchMedia('(max-width: 760px)');
      var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      var currentIndex = 0;
      var timer = null;

      function showMessage(index) {
        currentIndex = index % messages.length;
        var showAllMessages = mobileQuery.matches && reduceMotionQuery.matches;
        rotator.setAttribute('data-static-announcements', showAllMessages ? 'true' : 'false');
        messages.forEach(function (message, messageIndex) {
          var isCurrent = messageIndex === currentIndex;
          message.classList.toggle('is-active', showAllMessages || isCurrent);
          if (showAllMessages) message.removeAttribute('aria-hidden');
          else if (mobileQuery.matches) message.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
          else message.removeAttribute('aria-hidden');
        });
      }

      function stopRotation() {
        window.clearInterval(timer);
        timer = null;
      }

      function startRotation() {
        stopRotation();
        if (!mobileQuery.matches || reduceMotionQuery.matches || messages.length < 2 || document.hidden) return;
        timer = window.setInterval(function () { showMessage(currentIndex + 1); }, 6000);
      }

      function syncRotation() {
        showMessage(currentIndex);
        startRotation();
      }

      if (!messages.length) return;
      rotator.addEventListener('mouseenter', stopRotation);
      rotator.addEventListener('mouseleave', startRotation);
      rotator.addEventListener('focusin', stopRotation);
      rotator.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!rotator.contains(document.activeElement)) startRotation();
        }, 0);
      });
      document.addEventListener('visibilitychange', syncRotation);
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncRotation);
      else if (mobileQuery.addListener) mobileQuery.addListener(syncRotation);
      if (reduceMotionQuery.addEventListener) reduceMotionQuery.addEventListener('change', syncRotation);
      else if (reduceMotionQuery.addListener) reduceMotionQuery.addListener(syncRotation);
      rotator._announcementStop = stopRotation;
      syncRotation();
    });
  }

  function initSort(root) {
    (root || document).querySelectorAll('[data-sort-select]:not([data-initialized])').forEach(function (select) {
      select.setAttribute('data-initialized', 'true');
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  function initFilterDisclosures(root) {
    (root || document).querySelectorAll('.filters-disclosure:not([data-initialized])').forEach(function (disclosure) {
      disclosure.setAttribute('data-initialized', 'true');
      var desktopQuery = window.matchMedia('(min-width: 1281px)');
      function syncDisclosure() {
        if (desktopQuery.matches) {
          disclosure.open = true;
        } else if (disclosure.getAttribute('data-has-active') !== 'true') {
          disclosure.open = false;
        }
      }
      syncDisclosure();
      if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', syncDisclosure);
      else if (desktopQuery.addListener) desktopQuery.addListener(syncDisclosure);
    });
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>'"]/g, function (character) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character];
    });
  }

  function searchFormCopy(form) {
    return {
      available: form.getAttribute('data-copy-available') || '',
      preorder: form.getAttribute('data-copy-preorder') || '',
      sold: form.getAttribute('data-copy-sold') || '',
      viewAll: form.getAttribute('data-copy-view-all') || '',
      queries: form.getAttribute('data-copy-queries') || '',
      collections: form.getAttribute('data-copy-collections') || '',
      products: form.getAttribute('data-copy-products') || ''
    };
  }

  function shopifyRoute(path) {
    var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    if (routeRoot.charAt(routeRoot.length - 1) !== '/') routeRoot += '/';
    return new URL(String(path || '').replace(/^\/+/, ''), new URL(routeRoot, window.location.origin));
  }

  function searchResultsUrl(form, query) {
    var action = form.getAttribute('action') || shopifyRoute('search').toString();
    var url = new URL(action, window.location.origin);
    url.search = '';
    url.searchParams.set('q', query);
    Array.prototype.slice.call(form.elements || []).forEach(function (field) {
      if (!field.name || field.disabled || field.name === 'q') return;
      var type = String(field.type || '').toLowerCase();
      if (type === 'submit' || type === 'button' || type === 'image' || type === 'reset' || type === 'file') return;
      if ((type === 'checkbox' || type === 'radio') && !field.checked) return;
      if (field.tagName === 'SELECT' && field.multiple) {
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (option.selected) url.searchParams.append(field.name, option.value);
        });
        return;
      }
      url.searchParams.append(field.name, field.value);
    });
    if (!url.searchParams.has('type')) url.searchParams.set('type', 'product');
    if (!url.searchParams.has('options[prefix]')) url.searchParams.set('options[prefix]', 'last');
    return url;
  }

  function imageUrlWithWidth(source, width) {
    if (!source) return '';
    try {
      var url = new URL(source, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      return source;
    }
  }

  function predictivePrice(product) {
    var rawPrice = product && (product.price_min != null ? product.price_min : product.price);
    if (rawPrice == null || rawPrice === '') return '';
    var numericPrice = Number(String(rawPrice).replace(',', '.'));
    if (!isFinite(numericPrice)) return String(rawPrice);
    var currency = product.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    if (!currency || !window.Intl || !Intl.NumberFormat) return numericPrice.toFixed(2) + (currency ? ' ' + currency : '');
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(numericPrice);
    } catch (error) {
      return numericPrice.toFixed(2) + ' ' + currency;
    }
  }

  function predictiveStatus(product, copy) {
    var tags = product && Array.isArray(product.tags) ? product.tags.join(' ') : String(product && product.tags || '');
    var classification = [product && product.title, product && product.type, product && product.product_type, tags].join(' ');
    if (product && (product.available === false || product.available === 'false')) return { label: copy.sold, className: 'is-sold' };
    if (/\bpre[\s-]?order\b|preordine/i.test(classification)) return { label: copy.preorder, className: 'is-preorder' };
    if (product && typeof product.available === 'boolean') return { label: copy.available, className: 'is-available' };
    return null;
  }

  function initPredictiveSearch(root) {
    (root || document).querySelectorAll('[data-predictive-search]:not([data-initialized])').forEach(function (form) {
      form.setAttribute('data-initialized', 'true');
      var searchMode = form.getAttribute('data-search-mode');
      if (searchMode === 'tcg-pop' || searchMode === 'sports') return;
      var input = form.querySelector('[data-predictive-input]');
      var results = form.querySelector('[data-predictive-results]');
      if (!input || !results) return;
      var copy = searchFormCopy(form);
      var controller = null;
      var timer = null;
      var lastQuery = '';
      var activeIndex = -1;

      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-haspopup', 'listbox');
      results.setAttribute('role', 'listbox');

      function resultOptions() {
        return Array.prototype.slice.call(results.querySelectorAll('[data-predictive-option]'));
      }

      function setActiveResult(index) {
        var options = resultOptions();
        if (!options.length) {
          activeIndex = -1;
          input.removeAttribute('aria-activedescendant');
          return;
        }
        activeIndex = Math.max(0, Math.min(index, options.length - 1));
        options.forEach(function (option, optionIndex) {
          var active = optionIndex === activeIndex;
          option.classList.toggle('is-active', active);
          option.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        input.setAttribute('aria-activedescendant', options[activeIndex].id);
        options[activeIndex].scrollIntoView({ block: 'nearest' });
      }

      function closeResults() {
        window.clearTimeout(timer);
        timer = null;
        lastQuery = '';
        if (controller) controller.abort();
        controller = null;
        activeIndex = -1;
        results.hidden = true;
        results.innerHTML = '';
        results.removeAttribute('aria-busy');
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
      }

      function render(resources, query) {
        if (query !== lastQuery || input.value.trim() !== query || document.activeElement !== input) return;
        var products = Array.isArray(resources.products) ? resources.products.slice(0, 5) : [];
        var queries = Array.isArray(resources.queries) ? resources.queries.slice(0, 3) : [];
        var collections = Array.isArray(resources.collections) ? resources.collections.slice(0, 2) : [];
        var optionPrefix = results.id || ('PredictiveResults-' + Math.random().toString(36).slice(2));
        var optionIndex = 0;
        var markup = '';
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');

        function group(label, links) {
          if (!links) return '';
          return '<div role="group" aria-label="' + escapeHTML(label) + '"><div class="predictive-result-group-label" aria-hidden="true">' + escapeHTML(label) + '</div>' + links + '</div>';
        }

        function textLinks(items, isQuery) {
          return items.map(function (item) {
            var title = isQuery ? item.text : item.title;
            if (!title || !item.url) return '';
            var url = new URL(item.url, window.location.origin);
            if (url.origin !== window.location.origin) return '';
            if (isQuery) url.searchParams.set('type', 'product');
            return '<a id="' + escapeHTML(optionPrefix + '-option-' + optionIndex++) + '" class="predictive-result-item predictive-result-text" href="' + escapeHTML(url.toString()) + '" role="option" aria-selected="false" tabindex="-1" data-predictive-option>' + escapeHTML(title) + '</a>';
          }).join('');
        }

        markup += group(copy.queries, textLinks(queries, true));
        markup += group(copy.collections, textLinks(collections, false));
        markup += group(copy.products, products.map(function (product) {
          var image = product.featured_image && product.featured_image.url ? product.featured_image.url : product.image || '';
          var price = predictivePrice(product);
          var status = predictiveStatus(product, copy);
          return '<a id="' + escapeHTML(optionPrefix + '-option-' + optionIndex++) + '" class="predictive-result-item" href="' + escapeHTML(product.url) + '" role="option" aria-selected="false" tabindex="-1" data-predictive-option>' +
            (image ? '<img src="' + escapeHTML(imageUrlWithWidth(image, 96)) + '" alt="" loading="lazy" width="64" height="64">' : '<span aria-hidden="true"></span>') +
            '<span class="predictive-result-copy"><span class="predictive-result-title">' + escapeHTML(product.title) + '</span>' +
            '<span class="predictive-result-meta">' + (price ? '<span class="predictive-result-price">' + escapeHTML(price) + '</span>' : '') +
            (status ? '<span class="predictive-result-status ' + status.className + '">' + escapeHTML(status.label) + '</span>' : '') + '</span></span></a>';
        }).join(''));
        if (!markup) markup = '<div class="predictive-result-empty">' + escapeHTML(form.getAttribute('data-empty-text')) + '</div>';
        markup += '<a id="' + escapeHTML(optionPrefix + '-option-' + optionIndex) + '" class="predictive-view-all" href="' + escapeHTML(searchResultsUrl(form, query).toString()) + '" role="option" aria-selected="false" tabindex="-1" data-predictive-option>' + escapeHTML(copy.viewAll) + '</a>';
        results.innerHTML = markup;
        results.removeAttribute('aria-busy');
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      input.addEventListener('input', function () {
        var query = input.value.trim();
        lastQuery = query;
        window.clearTimeout(timer);
        if (controller) controller.abort();
        controller = null;
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
        input.setAttribute('aria-expanded', 'false');
        results.hidden = true;
        results.innerHTML = '';
        results.removeAttribute('aria-busy');
        if (query.length < 2) {
          closeResults();
          return;
        }
        timer = window.setTimeout(function () {
          timer = null;
          controller = new AbortController();
          var url = shopifyRoute('search/suggest.json');
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'query,product,collection');
          url.searchParams.set('resources[limit]', '5');
          url.searchParams.set('resources[limit_scope]', 'each');
          url.searchParams.set('resources[options][unavailable_products]', 'last');
          results.setAttribute('aria-busy', 'true');
          fetch(url.toString(), { signal: controller.signal, headers: { Accept: 'application/json' } })
            .then(function (response) { return response.ok ? response.json() : Promise.reject(response); })
            .then(function (data) {
              var resources = data && data.resources && data.resources.results ? data.resources.results : {};
              render(resources, query);
            })
            .catch(function (error) { if (error && error.name !== 'AbortError' && query === lastQuery) closeResults(); });
        }, 180);
      });

      input.addEventListener('focus', function () {
        if (results.innerHTML.trim()) {
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        }
      });

      input.addEventListener('keydown', function (event) {
        var options = resultOptions();
        if (event.key === 'Escape') {
          closeResults();
        } else if (event.key === 'ArrowDown' && !results.hidden && options.length) {
          event.preventDefault();
          setActiveResult(activeIndex < 0 ? 0 : activeIndex + 1);
        } else if (event.key === 'ArrowUp' && !results.hidden && options.length) {
          event.preventDefault();
          setActiveResult(activeIndex < 0 ? options.length - 1 : activeIndex - 1);
        } else if (event.key === 'Home' && !results.hidden && options.length) {
          event.preventDefault();
          setActiveResult(0);
        } else if (event.key === 'End' && !results.hidden && options.length) {
          event.preventDefault();
          setActiveResult(options.length - 1);
        } else if (event.key === 'Enter' && activeIndex >= 0 && options[activeIndex]) {
          event.preventDefault();
          window.location.assign(options[activeIndex].href);
        }
      });

      results.addEventListener('mousemove', function (event) {
        var option = event.target && event.target.closest ? event.target.closest('[data-predictive-option]') : null;
        if (option) {
          var options = resultOptions();
          setActiveResult(options.indexOf(option));
        }
      });

      form.addEventListener('submit', function (event) {
        var options = resultOptions();
        if (activeIndex >= 0 && options[activeIndex]) {
          event.preventDefault();
          window.location.assign(options[activeIndex].href);
        }
      });

      form.addEventListener('focusout', function () {
        window.setTimeout(function () { if (!form.contains(document.activeElement)) closeResults(); }, 0);
      });
    });
  }

  var languageLastToggle = null;
  function closeLanguagePanels(restoreFocus) {
    document.querySelectorAll('[data-language-panel]').forEach(function (panel) { panel.hidden = true; });
    document.querySelectorAll('[data-language-toggle]').forEach(function (toggle) { toggle.setAttribute('aria-expanded', 'false'); });
    if (restoreFocus && languageLastToggle) languageLastToggle.focus();
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target && event.target.closest ? event.target.closest('[data-language-toggle]') : null;
    if (toggle) {
      event.preventDefault();
      var form = toggle.closest('[data-language-form]');
      var panel = form ? form.querySelector('[data-language-panel]') : null;
      var wasOpen = panel && !panel.hidden;
      closeLanguagePanels(false);
      if (panel && !wasOpen) {
        languageLastToggle = toggle;
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        var firstOption = panel.querySelector('button');
        if (firstOption) firstOption.focus();
      }
      return;
    }

    var localeButton = event.target && event.target.closest ? event.target.closest('[data-locale-code]') : null;
    if (localeButton) {
      event.preventDefault();
      var localeForm = localeButton.closest('form');
      var localeInput = localeForm ? localeForm.querySelector('[data-language-input]') : null;
      if (localeInput) {
        localeInput.value = localeButton.getAttribute('data-locale-code');
        localeForm.submit();
      }
      return;
    }
    if (!event.target.closest('[data-language-form]')) closeLanguagePanels(false);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.querySelector('[data-language-panel]:not([hidden])')) {
      event.preventDefault();
      closeLanguagePanels(true);
    }
  });

  function numberAttribute(element, name, fallback) {
    var rawValue = element ? element.getAttribute(name) : null;
    if (rawValue == null || rawValue === '') return fallback;
    var numericValue = Number(rawValue);
    return isFinite(numericValue) ? numericValue : fallback;
  }

  function normalizedQuantity(value, minimum, maximum, increment) {
    var safeMinimum = isFinite(minimum) ? minimum : 1;
    var safeIncrement = isFinite(increment) && increment > 0 ? increment : 1;
    var safeMaximum = isFinite(maximum) ? Math.max(safeMinimum, maximum) : NaN;
    var safeValue = isFinite(value) ? value : safeMinimum;
    safeValue = Math.max(safeMinimum, safeValue);
    if (isFinite(safeMaximum)) safeValue = Math.min(safeMaximum, safeValue);
    var steps = Math.floor(((safeValue - safeMinimum) / safeIncrement) + 0.0000001);
    safeValue = safeMinimum + (Math.max(0, steps) * safeIncrement);
    if (isFinite(safeMaximum)) {
      var maximumSteps = Math.floor(((safeMaximum - safeMinimum) / safeIncrement) + 0.0000001);
      safeValue = Math.min(safeMinimum + (Math.max(0, maximumSteps) * safeIncrement), safeValue);
    }
    return Number(safeValue.toFixed(6));
  }

  function normalizeQuantityInput(input) {
    if (!input) return;
    var minimum = numberAttribute(input, 'min', 1);
    var maximum = numberAttribute(input, 'max', NaN);
    var increment = numberAttribute(input, 'step', 1);
    input.value = String(normalizedQuantity(Number(input.value), minimum, maximum, increment));
  }

  function normalizeFormQuantities(form) {
    if (!form) return;
    form.querySelectorAll('[data-quantity-rules]').forEach(normalizeQuantityInput);
  }

  function initQuantityRules(root) {
    (root || document).querySelectorAll('[data-quantity-rules]:not([data-quantity-initialized])').forEach(function (input) {
      input.setAttribute('data-quantity-initialized', 'true');
      input.addEventListener('change', function () { normalizeQuantityInput(input); });
      input.addEventListener('blur', function () { normalizeQuantityInput(input); });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') normalizeQuantityInput(input);
      });
      var form = input.form;
      if (form && !form.hasAttribute('data-quantity-submit-initialized')) {
        form.setAttribute('data-quantity-submit-initialized', 'true');
        form.addEventListener('click', function (event) {
          var submitter = event.target && event.target.closest ? event.target.closest('button[type="submit"], input[type="submit"]') : null;
          if (submitter) normalizeFormQuantities(form);
        });
        form.addEventListener('submit', function () { normalizeFormQuantities(form); });
      }
    });
  }

  function dispatchVariantChange(productRoot, available) {
    if (!productRoot) return;
    var variantEvent;
    try {
      variantEvent = new CustomEvent('cardshub:variant-change', { detail: { available: available } });
    } catch (error) {
      variantEvent = document.createEvent('CustomEvent');
      variantEvent.initCustomEvent('cardshub:variant-change', false, false, { available: available });
    }
    productRoot.dispatchEvent(variantEvent);
  }

  function initVariantSelectors(root) {
    (root || document).querySelectorAll('[data-variant-select]:not([data-initialized])').forEach(function (select) {
      select.setAttribute('data-initialized', 'true');
      var panel = select.closest('.product-info-panel');
      if (!panel) return;
      var price = panel.querySelector('[data-product-current-price]');
      var compare = panel.querySelector('[data-product-compare]');
      var skuContainer = panel.querySelector('[data-product-sku]');
      var sku = skuContainer ? skuContainer.querySelector('span') : null;
      var button = panel.querySelector('[data-add-to-cart]');
      var status = panel.querySelector('[data-product-status]');
      var stock = panel.querySelector('[data-product-stock]');
      var dynamicCheckout = panel.querySelector('[data-dynamic-checkout]');
      var quantity = panel.querySelector('[data-product-quantity]');
      var barcodeContainer = panel.querySelector('[data-product-barcode]');
      var barcode = barcodeContainer ? barcodeContainer.querySelector('dd') : null;
      var productRoot = panel.closest('.product-main');
      var stickyPrice = productRoot ? productRoot.querySelector('[data-sticky-product-price]') : null;

      function syncVariant(updateUrl) {
        var option = select.options[select.selectedIndex];
        if (!option) return;
        var available = option.getAttribute('data-available') === 'true';
        var priceText = option.getAttribute('data-price') || '';
        if (price) price.textContent = priceText;
        if (stickyPrice) stickyPrice.textContent = priceText;
        if (compare) {
          var compareText = option.getAttribute('data-compare-price') || '';
          compare.textContent = compareText;
          compare.hidden = !compareText;
        }
        if (sku && skuContainer) {
          sku.textContent = option.getAttribute('data-sku') || '';
          skuContainer.hidden = !sku.textContent;
        }
        if (barcode && barcodeContainer) {
          barcode.textContent = option.getAttribute('data-barcode') || '';
          barcodeContainer.hidden = !barcode.textContent;
        }
        if (quantity) {
          var minimum = numberAttribute(option, 'data-min-quantity', 1);
          var maximum = numberAttribute(option, 'data-max-quantity', NaN);
          var increment = numberAttribute(option, 'data-quantity-increment', 1);
          quantity.min = String(minimum);
          quantity.step = String(increment);
          if (isFinite(maximum)) quantity.max = String(maximum);
          else quantity.removeAttribute('max');
          normalizeQuantityInput(quantity);
        }
        if (button) {
          button.disabled = !available;
          button.textContent = available ? button.getAttribute('data-add-label') : button.getAttribute('data-sold-label');
        }
        if (dynamicCheckout) dynamicCheckout.hidden = !available;
        if (status) {
          var preorder = status.getAttribute('data-preorder') === 'true';
          status.textContent = available ? status.getAttribute(preorder ? 'data-preorder-label' : 'data-available-label') : status.getAttribute('data-sold-label');
        }
        if (stock) {
          var stockText = option.getAttribute('data-stock-label') || '';
          stock.textContent = stockText;
          stock.hidden = !stockText;
        }
        dispatchVariantChange(productRoot, available);
        if (updateUrl && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url.toString());
        }
      }

      select.addEventListener('change', function () {
        syncVariant(true);
      });
      syncVariant(false);
    });
  }

  function initStickyBuy(root) {
    (root || document).querySelectorAll('[data-sticky-buy]:not([data-initialized])').forEach(function (sticky) {
      sticky.setAttribute('data-initialized', 'true');
      sticky.setAttribute('aria-hidden', 'true');
      var productRoot = sticky.closest('.product-main');
      var primaryButton = productRoot ? productRoot.querySelector('[data-add-to-cart]') : null;
      var stickyButton = sticky.querySelector('[data-sticky-buy-trigger]');
      if (!productRoot || !primaryButton) return;
      var observer = null;
      var frame = null;

      function syncSticky() {
        var buttonRect = primaryButton.getBoundingClientRect();
        var productRect = productRoot.getBoundingClientRect();
        var show = !sticky.hidden && !primaryButton.disabled && buttonRect.bottom < 0 && productRect.bottom > window.innerHeight;
        if (stickyButton) stickyButton.disabled = primaryButton.disabled;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      function queueStickySync() {
        if (frame != null) return;
        frame = window.requestAnimationFrame(function () {
          frame = null;
          syncSticky();
        });
      }

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(queueStickySync, { threshold: 0 });
        observer.observe(primaryButton);
      }
      window.addEventListener('scroll', queueStickySync, { passive: true });
      window.addEventListener('resize', queueStickySync);
      var variantChangeHandler = function (event) {
        sticky.hidden = !(event.detail && event.detail.available);
        queueStickySync();
      };
      productRoot.addEventListener('cardshub:variant-change', variantChangeHandler);
      sticky._stickyCleanup = function () {
        if (observer) observer.disconnect();
        if (frame != null) window.cancelAnimationFrame(frame);
        window.removeEventListener('scroll', queueStickySync);
        window.removeEventListener('resize', queueStickySync);
        productRoot.removeEventListener('cardshub:variant-change', variantChangeHandler);
      };
      syncSticky();
    });
  }

  var zoomModal = null;
  var zoomImage = null;
  var zoomLastTrigger = null;

  function ensureZoomModal(trigger) {
    if (zoomModal) return zoomModal;
    zoomModal = document.createElement('div');
    zoomModal.className = 'product-zoom-modal';
    zoomModal.setAttribute('role', 'dialog');
    zoomModal.setAttribute('aria-modal', 'true');
    zoomModal.innerHTML = '<button type="button" class="product-zoom-modal__close">×</button><img class="product-zoom-modal__image" alt="">';
    document.body.appendChild(zoomModal);
    zoomImage = zoomModal.querySelector('.product-zoom-modal__image');
    zoomModal.addEventListener('click', function (event) {
      if (event.target === zoomModal || event.target.closest('.product-zoom-modal__close') || event.target === zoomImage) closeZoom();
    });
    return zoomModal;
  }

  function openZoom(trigger) {
    ensureZoomModal(trigger);
    zoomLastTrigger = trigger;
    var sourceImage = trigger.querySelector('img');
    zoomModal.setAttribute('aria-label', trigger.getAttribute('data-dialog-label') || '');
    zoomModal.querySelector('.product-zoom-modal__close').setAttribute('aria-label', trigger.getAttribute('data-close-label') || '');
    zoomImage.src = trigger.getAttribute('href');
    zoomImage.alt = sourceImage ? sourceImage.getAttribute('alt') || '' : '';
    zoomModal.classList.add('is-open');
    setPageInert(true);
    document.documentElement.style.overflow = 'hidden';
    zoomModal.querySelector('.product-zoom-modal__close').focus();
  }

  function closeZoom() {
    if (!zoomModal || !zoomModal.classList.contains('is-open')) return;
    zoomModal.classList.remove('is-open');
    setPageInert(false);
    document.documentElement.style.overflow = '';
    if (zoomLastTrigger) zoomLastTrigger.focus();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest ? event.target.closest('[data-product-zoom]') : null;
    if (!trigger) return;
    event.preventDefault();
    openZoom(trigger);
  });

  document.addEventListener('keydown', function (event) {
    if (!zoomModal || !zoomModal.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeZoom();
    } else if (event.key === 'Tab') {
      event.preventDefault();
      zoomModal.querySelector('.product-zoom-modal__close').focus();
    }
  });

  function normalizeDepartmentSearchText(value) {
    var normalized = String(value || '').toLowerCase();
    if (normalized.normalize) normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return normalized.replace(/[^a-z0-9\u00c0-\u024f\u3040-\u30ff\u3400-\u9fff]+/g, ' ').trim();
  }

  function departmentSearchTemplate(template, count, terms) {
    return String(template || '')
      .replace(/__COUNT__/g, function () { return String(count); })
      .replace(/__TERMS__/g, function () { return String(terms || ''); });
  }

  function initDepartmentSearch(root) {
    (root || document).querySelectorAll('[data-department-search]:not([data-initialized])').forEach(function (searchRoot) {
      searchRoot.setAttribute('data-initialized', 'true');

      var results = searchRoot.querySelector('[data-department-search-results]');
      var emptyState = searchRoot.querySelector('[data-department-search-empty]');
      var errorState = searchRoot.querySelector('[data-department-search-error]');
      var loading = searchRoot.querySelector('[data-department-search-loading]');
      var summary = searchRoot.querySelector('[data-department-search-summary]');
      var sortSelect = searchRoot.querySelector('[data-department-search-sort]');
      var pagination = searchRoot.querySelector('[data-department-search-pagination]');
      var previousButton = searchRoot.querySelector('[data-department-search-previous]');
      var nextButton = searchRoot.querySelector('[data-department-search-next]');
      var pageStatus = searchRoot.querySelector('[data-department-search-page-status]');

      if (!results || !emptyState || !errorState || !loading || !summary || !pagination || !previousButton || !nextButton || !pageStatus) return;

      var sourceUrl = searchRoot.getAttribute('data-source-url') || '';
      var sourceHandle = searchRoot.getAttribute('data-source-handle') || '';
      var indexSection = searchRoot.getAttribute('data-index-section') || 'department-search-index';
      var indexPageSize = parseInt(searchRoot.getAttribute('data-index-page-size'), 10);
      var expectedCount = parseInt(searchRoot.getAttribute('data-expected-count'), 10);
      var pageSize = parseInt(searchRoot.getAttribute('data-page-size'), 10);
      var query = searchRoot.getAttribute('data-query') || '';
      var hasRawQuery = String(query).trim().length > 0;
      var normalizedQuery = normalizeDepartmentSearchText(query);
      var queryTokens = normalizedQuery ? normalizedQuery.split(/\s+/).filter(Boolean) : [];
      var countOneTemplate = searchRoot.getAttribute('data-count-one') || '';
      var countManyTemplate = searchRoot.getAttribute('data-count-many') || '';
      var pageLabel = searchRoot.getAttribute('data-page-label') || '';
      var initialSort = searchRoot.getAttribute('data-initial-sort') || 'relevance';
      var locationUrl = new URL(window.location.href);
      var currentSort = locationUrl.searchParams.get('sort_by') || initialSort;
      var currentPage = Math.max(1, parseInt(locationUrl.searchParams.get('page'), 10) || 1);
      var entries = [];
      var filteredEntries = [];
      var seenProducts = {};
      var controller = typeof AbortController === 'function' ? new AbortController() : null;

      if (!isFinite(expectedCount) || expectedCount < 0) expectedCount = 0;
      if (!isFinite(pageSize) || pageSize < 1) pageSize = 24;
      if (!isFinite(indexPageSize) || indexPageSize < 1) indexPageSize = 48;

      if (sortSelect) {
        var requestedOption = Array.prototype.slice.call(sortSelect.options).some(function (option) { return option.value === currentSort; });
        if (requestedOption) sortSelect.value = currentSort;
        else currentSort = sortSelect.value || 'relevance';
        sortSelect.disabled = true;
      }

      function setBusy(busy) {
        searchRoot.setAttribute('aria-busy', busy ? 'true' : 'false');
        loading.hidden = !busy;
      }

      function failClosed(error) {
        setBusy(false);
        searchRoot.setAttribute('data-search-scope-ready', 'false');
        results.hidden = true;
        results.innerHTML = '';
        pagination.hidden = true;
        emptyState.hidden = true;
        errorState.hidden = false;
        pageStatus.textContent = '';
        summary.textContent = '';
        if (window.console && console.error) console.error('Department search failed closed.', error);
      }

      function indexRequestUrl(page) {
        var url = new URL(sourceUrl, window.location.origin);
        url.searchParams.set('section_id', indexSection);
        url.searchParams.set('page', String(page));
        ['preview_theme_id', '_fd', 'pb'].forEach(function (parameter) {
          var value = locationUrl.searchParams.get(parameter);
          if (value != null) url.searchParams.set(parameter, value);
        });
        return url.toString();
      }

      function readIndexPage(html, requestedPage) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var index = parsed.querySelector('[data-department-search-index]');
        if (!index) throw new Error('Missing department search index.');
        if (index.getAttribute('data-collection-handle') !== sourceHandle) throw new Error('Department collection mismatch.');
        if (parseInt(index.getAttribute('data-current-page'), 10) !== requestedPage) throw new Error('Department index page mismatch.');
        if (parseInt(index.getAttribute('data-page-size'), 10) !== indexPageSize) throw new Error('Department index page size mismatch.');

        Array.prototype.slice.call(index.querySelectorAll('[data-department-search-product]')).forEach(function (wrapper) {
          var productId = wrapper.getAttribute('data-product-id') || '';
          var card = wrapper.querySelector('.product-card');
          if (!productId || !card || seenProducts[productId]) throw new Error('Invalid or duplicate department product.');
          seenProducts[productId] = true;
          entries.push({
            id: productId,
            card: card,
            index: normalizeDepartmentSearchText(wrapper.getAttribute('data-search-index')),
            title: normalizeDepartmentSearchText(wrapper.getAttribute('data-title')),
            vendor: normalizeDepartmentSearchText(wrapper.getAttribute('data-vendor')),
            price: Number(wrapper.getAttribute('data-price')) || 0,
            createdAt: Date.parse(wrapper.getAttribute('data-created-at')) || 0,
            position: entries.length,
            score: 0
          });
        });

        return parseInt(index.getAttribute('data-next-page'), 10) || 0;
      }

      function requestIndexPage(page) {
        var requestOptions = { headers: { Accept: 'text/html' } };
        if (controller) requestOptions.signal = controller.signal;
        return fetch(indexRequestUrl(page), requestOptions)
          .then(function (response) {
            if (!response.ok) throw new Error('Department index request failed: ' + response.status);
            return response.text();
          })
          .then(function (html) { return { page: page, html: html }; });
      }

      function loadDepartmentIndex() {
        // Shopify Liquid pagination can't access items beyond the 25,000th item.
        // Four-request batches avoid a burst while keeping the current catalog fast.
        var liquidPaginationItemLimit = 25000;
        var sourcePageCount = Math.max(1, Math.ceil(expectedCount / indexPageSize));
        if (expectedCount > liquidPaginationItemLimit) return Promise.reject(new Error('Department index exceeds Shopify Liquid pagination limits.'));

        function loadBatch(firstPage) {
          if (firstPage > sourcePageCount) return Promise.resolve(entries);
          var lastPage = Math.min(sourcePageCount, firstPage + 3);
          var requests = [];
          for (var page = firstPage; page <= lastPage; page += 1) requests.push(requestIndexPage(page));
          return Promise.all(requests).then(function (pages) {
            pages.forEach(function (pageResult) {
              var nextPage = readIndexPage(pageResult.html, pageResult.page);
              var expectedNextPage = pageResult.page < sourcePageCount ? pageResult.page + 1 : 0;
              if (nextPage !== expectedNextPage) throw new Error('Invalid department index pagination.');
            });
            return loadBatch(lastPage + 1);
          });
        }

        return loadBatch(1).catch(function (error) {
          if (controller) controller.abort();
          throw error;
        });
      }

      function relevanceScore(entry) {
        if (!normalizedQuery) return 0;
        var score = 0;
        if (entry.title === normalizedQuery) score += 1000;
        else if (entry.title.indexOf(normalizedQuery) === 0) score += 500;
        else if (entry.title.indexOf(normalizedQuery) !== -1) score += 250;
        queryTokens.forEach(function (token) {
          if (entry.title.indexOf(token) !== -1) score += 30;
          else if (entry.vendor.indexOf(token) !== -1) score += 10;
          else if (entry.index.indexOf(token) !== -1) score += 2;
        });
        return score;
      }

      function compareEntries(left, right) {
        if (currentSort === 'price-ascending') return left.price - right.price || left.position - right.position;
        if (currentSort === 'price-descending') return right.price - left.price || left.position - right.position;
        if (currentSort === 'created-ascending' || currentSort === 'date-ascending') return left.createdAt - right.createdAt || left.position - right.position;
        if (currentSort === 'created-descending' || currentSort === 'date-descending') return right.createdAt - left.createdAt || left.position - right.position;
        if (currentSort === 'title-ascending') return left.title.localeCompare(right.title) || left.position - right.position;
        if (currentSort === 'title-descending') return right.title.localeCompare(left.title) || left.position - right.position;
        return right.score - left.score || left.position - right.position;
      }

      function filterAndSort() {
        filteredEntries = entries.filter(function (entry) {
          if (hasRawQuery && !queryTokens.length) return false;
          var matches = queryTokens.every(function (token) { return entry.index.indexOf(token) !== -1; });
          if (matches) entry.score = relevanceScore(entry);
          return matches;
        });
        filteredEntries.sort(compareEntries);
      }

      function syncUrl() {
        var url = new URL(window.location.href);
        var ignoredParameters = [];
        url.searchParams.forEach(function (value, key) {
          if (key === 'type' || key.indexOf('filter.') === 0 || key.indexOf('options[') === 0) ignoredParameters.push(key);
        });
        ignoredParameters.forEach(function (key) { url.searchParams.delete(key); });
        if (currentSort && currentSort !== 'relevance') url.searchParams.set('sort_by', currentSort);
        else url.searchParams.delete('sort_by');
        if (currentPage > 1) url.searchParams.set('page', String(currentPage));
        else url.searchParams.delete('page');
        window.history.replaceState(window.history.state, '', url.toString());
      }

      function renderPage(shouldScroll) {
        var count = filteredEntries.length;
        var totalPages = Math.max(1, Math.ceil(count / pageSize));
        currentPage = Math.min(Math.max(1, currentPage), totalPages);
        results.innerHTML = '';
        summary.textContent = departmentSearchTemplate(count === 1 ? countOneTemplate : countManyTemplate, count, query);

        if (!count) {
          results.hidden = true;
          emptyState.hidden = false;
          errorState.hidden = true;
          pagination.hidden = true;
          pageStatus.textContent = '';
        } else {
          var start = (currentPage - 1) * pageSize;
          filteredEntries.slice(start, start + pageSize).forEach(function (entry) { results.appendChild(entry.card); });
          results.hidden = false;
          emptyState.hidden = true;
          errorState.hidden = true;
          pagination.hidden = totalPages <= 1;
          previousButton.disabled = currentPage <= 1;
          nextButton.disabled = currentPage >= totalPages;
          pageStatus.textContent = pageLabel + ' ' + currentPage + ' / ' + totalPages;
          init(results);
        }

        syncUrl();
        if (shouldScroll && count) {
          try { results.focus({ preventScroll: true }); }
          catch (error) { results.focus(); }
          var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          results.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
      }

      setBusy(true);
      loadDepartmentIndex()
        .then(function () {
          if (entries.length !== expectedCount) throw new Error('Department index count mismatch: expected ' + expectedCount + ', received ' + entries.length + '.');
          filterAndSort();
          searchRoot.setAttribute('data-search-scope-ready', 'true');
          searchRoot.setAttribute('data-indexed-product-count', String(entries.length));
          if (sortSelect) sortSelect.disabled = false;
          setBusy(false);
          renderPage(false);
        })
        .catch(function (error) {
          if (!error || error.name !== 'AbortError') failClosed(error);
        });

      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          currentSort = sortSelect.value || 'relevance';
          currentPage = 1;
          filterAndSort();
          renderPage(false);
        });
      }
      previousButton.addEventListener('click', function () {
        if (currentPage <= 1) return;
        currentPage -= 1;
        renderPage(true);
      });
      nextButton.addEventListener('click', function () {
        var totalPages = Math.max(1, Math.ceil(filteredEntries.length / pageSize));
        if (currentPage >= totalPages) return;
        currentPage += 1;
        renderPage(true);
      });

      searchRoot._departmentSearchCleanup = function () { if (controller) controller.abort(); };
    });
  }

  function init(root) {
    initAnnouncementRotators(root);
    initSort(root);
    initFilterDisclosures(root);
    initPredictiveSearch(root);
    initDepartmentSearch(root);
    initQuantityRules(root);
    initVariantSelectors(root);
    initStickyBuy(root);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var rotator = event.target.querySelector('[data-announcement-rotator]');
    if (rotator && rotator._announcementStop) rotator._announcementStop();
    event.target.querySelectorAll('[data-department-search]').forEach(function (searchRoot) {
      if (searchRoot._departmentSearchCleanup) searchRoot._departmentSearchCleanup();
    });
    event.target.querySelectorAll('[data-sticky-buy]').forEach(function (sticky) {
      if (sticky._stickyCleanup) sticky._stickyCleanup();
    });
  });
})();
